import React from 'react'
import LoadingSpinner from './LoadingSpinner'

export default function PageLoader({
  label = 'Loading…',
  compact = false,
  'data-testid': dataTestId
}: {
  label?: string
  compact?: boolean
  'data-testid'?: string
}) {
  return (
    <div
      data-testid={dataTestId}
      className={
        compact
          ? 'flex flex-col items-center justify-center gap-3 px-6 py-12'
          : 'flex min-h-[40vh] flex-col items-center justify-center gap-3 px-6 py-16'
      }
    >
      <LoadingSpinner />
      <p className="text-sm text-gray-600">{label}</p>
    </div>
  )
}
